import script from "./QuizzIllustrationPlaceholder.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuizzIllustrationPlaceholder.vue?vue&type=script&setup=true&lang=ts"

import "./QuizzIllustrationPlaceholder.vue?vue&type=style&index=0&id=58e0f44b&scoped=true&lang=scss"

import exportComponent from "D:\\wamp\\www\\GSALT\\gsalt-matters-ibd-denmark\\web\\modules\\vuejs\\vuejs-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58e0f44b"]])

export default __exports__